import { render, staticRenderFns } from "./PotentialCustomer.vue?vue&type=template&id=145e39f6"
import script from "./PotentialCustomer.vue?vue&type=script&lang=ts"
export * from "./PotentialCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports